import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  requestWkblVideoList,
  changeWkblVideoPage,
  changeWkblVideoSort,
  changeWkblVideoAsc,
  changeWkblVideoReturnCount,
  clearWkblVideoList,
} from 'redux/actions/actions';
import { RootState } from 'redux/reducers/type';
import WkblVideoParamVO from 'commons/vo/param/WkblVideoParamVO';
import { AscType, SortType } from 'commons/constants/type';

function useWkblVideo() {
  const dispatch = useDispatch();

  const onRequestWkblVideoList = useCallback(
    (param: WkblVideoParamVO) => {
      dispatch(requestWkblVideoList({ param }));
    },
    [dispatch],
  );

  const onClearWkblVideoList = useCallback(() => {
    dispatch(clearWkblVideoList());
  }, [dispatch]);

  const onChangeWkblVideoPage = useCallback(
    (pageNumber: number) => {
      dispatch(changeWkblVideoPage({ pageNumber }));
    },
    [dispatch],
  );

  const onChangeWkblVideoSort = useCallback(
    (sort: SortType) => {
      dispatch(changeWkblVideoSort({ sort }));
    },
    [dispatch],
  );
  const onChangeWkblVideoAsc = useCallback(
    (asc: AscType) => {
      dispatch(changeWkblVideoAsc({ asc }));
    },
    [dispatch],
  );

  const onChangeWkblVideoReturnCount = useCallback(
    (returnCount: number) => {
      dispatch(changeWkblVideoReturnCount({ returnCount }));
    },
    [dispatch],
  );

  return useMemo(() => {
    return {
      onRequestWkblVideoList,
      onClearWkblVideoList,
      onChangeWkblVideoPage,
      onChangeWkblVideoSort,
      onChangeWkblVideoAsc,
      onChangeWkblVideoReturnCount,
    };
  }, [
    onRequestWkblVideoList,
    onClearWkblVideoList,
    onChangeWkblVideoPage,
    onChangeWkblVideoSort,
    onChangeWkblVideoAsc,
    onChangeWkblVideoReturnCount,
  ]);
}

export default useWkblVideo;
